import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import CaptchaImage, { generateCaptcha } from "../../globalUtilities/captcha";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import "../../assets/css/login.css";
import logo from "../../assets/images/tb_logo.png";
import { Password } from "primereact/password";
import { isValidPassword } from "../../utils/commonLogics";
import { setNewPasswordApi } from "../../services/auth/login";
import AuthCommonLeftPart from "./AuthCommonLeftPart";
// import PasswordInfoTooltip from "../../components/sharedComponents/PasswordInfoTooltip";

const SetNewPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tstring = searchParams.get("tstring");
  const op = useRef(null);

  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [resetPwdForm, setResetPwdForm] = useState({
    new_password: "",
    confirm_password: "",
    enteredCaptcha: "",
  });

  const [resetPwdFormErrors, setResetPwdFormErrors] = useState({});

  // const memoizedContentPwdTooltip = useMemo(() => (
  //     <div className="tooltip-content text-start">
  //         <span>- Must contain minimum 8 characters</span><br />
  //         <span>- Must contain at least 1 uppercase letter</span><br />
  //         <span>- Must contain at least 1 lowercase letter</span><br />
  //         <span>
  //             - Must contain at least 1 special character
  //             (! ~ ` @ # $ % ^ &amp; * ( ) &lt; = &gt; ? &quot; + ' / : ; , - &#123; _ &#125; |)
  //         </span><br />
  //         <span>- Must contain at least 1 number</span>
  //     </div>
  // ), []);

  useEffect(() => {
    if (Object.keys(resetPwdFormErrors).length === 0 && isSubmitting) {
      submitForm();
    } else {
      setIsSubmitting(false);
    }
  }, [resetPwdFormErrors]);

  const handleResetFormChange = (e) => {
    setResetPwdForm((prevProp) => ({
      ...prevProp,
      [e.target.name]: e.target.value,
    }));
  };

  const submitForm = () => {
    let payload = {
      new_password: resetPwdForm.new_password,
      t_string: tstring,
    };

    setNewPasswordApi(payload)
      .then((response) => {
        if (response?.data?.message) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: response?.data?.message,
            life: 3000,
          });
          setIsSubmitting(false);
          setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
          setResetPwdForm({
            new_password: "",
            confirm_password: "",
            enteredCaptcha: "",
          }); //Reset form data
          setTimeout(() => {
            navigate("/login");
          }, 800); // Delay navigation by 800ms
        } else {
          console.error("There is some issue in email link sending");
          setIsSubmitting(false);
          setResetPwdForm({
            enteredCaptcha: "",
          }); //Reset form data
          setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error?.response?.data?.message,
          life: 3000,
        });
        setResetPwdForm({
          enteredCaptcha: "",
        }); //Reset form data
        setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
      });
  };

  const validateForm = (values) => {
    let errors = {};
    if (!values.new_password) {
      errors.new_password = "New password is required.";
    } else if (values.new_password.length < 8) {
      errors.new_password = "Password must be 8 character long.";
    } else if (!isValidPassword(values.new_password)) {
      errors.new_password = "Invalid password format.";
    }
    if (!values.confirm_password) {
      errors.confirm_password = "Confirm new password is required.";
    } else if (values.confirm_password !== values.new_password) {
      errors.confirm_password =
        "Confirm new password must match with new password.";
    }
    if (!values.enteredCaptcha) {
      errors.enteredCaptcha = "Please enter captcha.";
    } else if (values.enteredCaptcha !== captcha) {
      errors.enteredCaptcha = "Invalid captcha. Please try again.";
      setCaptcha(generateCaptcha()); // Regenerate captcha if invalid
      setResetPwdForm((prevProp) => ({
        ...prevProp,
        enteredCaptcha: "",
      })); // Clear the entered captcha field
    }
    return errors;
  };

  const handleOnSubmit = () => {
    setResetPwdFormErrors(validateForm(resetPwdForm));
    setIsSubmitting(true);
  };

  return (
    <div className="container-fluid gradient-form">
      <Toast ref={toast} />
      {loading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50">
          <ProgressSpinner />
        </div>
      )}{" "}
      {/* Show spinner when loading is true */}
      <div className="row no-gutters" style={{ height: "100vh" }}>
        <AuthCommonLeftPart />

        <div className="col-md-7">
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className={"logo_padding_forgot_password"}>
              <img
                src={logo}
                style={{ width: "185px" }}
                alt="logo"
                className="image-fluid"
              />
            </div>

            <div className="read-terms fw-600" style={{ fontSize: "large" }}>
              Reset Password
            </div>
            <div className="login-form-pad-desktop-step-2 d-none d-md-block">
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-lock me-2 text-secondary"></span>
                <div className="w-100">
                  <div className="d-flex align-items-center position-relative">
                    <Password
                      autoFocus
                      value={resetPwdForm.new_password}
                      onChange={(e) => handleResetFormChange(e)}
                      toggleMask
                      feedback={false}
                      name="new_password"
                      placeholder="Enter new password"
                      className="username w-100"
                    />
                    {/* <div className="me-1 mt-2 text-info cursor-pointer" style={{
                                            position: "absolute",
                                            right: "-20px",
                                            width: "100%"
                                        }}>
                                            <PasswordInfoTooltip tooltipText={memoizedContentPwdTooltip} position="top">
                                                <span className="pi pi-info-circle text-info cursor-pointer"></span>
                                            </PasswordInfoTooltip>
                                        </div> */}
                  </div>
                  {resetPwdFormErrors.new_password && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.new_password}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-lock me-2 text-secondary"></span>
                <div className="w-100">
                  <InputText
                    type="password"
                    value={resetPwdForm.confirm_password}
                    onChange={(e) => handleResetFormChange(e)}
                    name="confirm_password"
                    placeholder="Confirm new password"
                    className="username w-100"
                  />
                  {resetPwdFormErrors.confirm_password && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.confirm_password}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-qrcode me-2 text-secondary"></span>
                <div className="w-100">
                  <InputText
                    value={resetPwdForm.enteredCaptcha}
                    onChange={(e) => handleResetFormChange(e)}
                    name="enteredCaptcha"
                    placeholder="Enter security code shown below"
                    className="username w-100"
                  />
                  {resetPwdFormErrors.enteredCaptcha && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.enteredCaptcha}
                    </div>
                  )}
                </div>
              </div>
              <div className="captcha-display">
                <CaptchaImage captcha={captcha} />
              </div>
              <div className="text-center pt-1 mt-4 pb-1">
                <Button
                  label={"SUBMIT"}
                  onClick={handleOnSubmit}
                  className="mb-4 w-100 fw-600 next-button"
                  style={{
                    backgroundColor: "#002133",
                  }}
                  loading={isSubmitting}
                />
              </div>
            </div>
            {/* Desktop View End */}
            {/* Mobile View Start */}
            <div className="login-form-pad-mobile-step-2 d-block d-md-none">
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-lock me-2 text-secondary"></span>
                <div className="w-100">
                  <div className="d-flex align-items-center position-relative">
                    <Password
                      autoFocus
                      value={resetPwdForm.new_password}
                      onChange={(e) => handleResetFormChange(e)}
                      toggleMask
                      feedback={false}
                      name="new_password"
                      placeholder="Enter new password"
                      className="username w-100"
                    />
                    {/* <div className="me-1 mt-2 text-info cursor-pointer" style={{
                                            position: "absolute",
                                            right: "-20px",
                                            width: "100%"
                                        }}>
                                            <PasswordInfoTooltip tooltipText={memoizedContentPwdTooltip} position="top">
                                                <span className="pi pi-info-circle text-info cursor-pointer"></span>
                                            </PasswordInfoTooltip>
                                        </div> */}
                  </div>
                  {resetPwdFormErrors.new_password && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.new_password}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-lock me-2 text-secondary"></span>
                <div className="w-100">
                  <InputText
                    type="password"
                    value={resetPwdForm.confirm_password}
                    onChange={(e) => handleResetFormChange(e)}
                    name="confirm_password"
                    placeholder="Confirm new password"
                    className="username w-100"
                  />
                  {resetPwdFormErrors.confirm_password && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.confirm_password}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <span className="pi pi-qrcode me-2 text-secondary"></span>
                <div className="w-100">
                  <InputText
                    value={resetPwdForm.enteredCaptcha}
                    onChange={(e) => handleResetFormChange(e)}
                    name="enteredCaptcha"
                    placeholder="Enter security code shown below"
                    className="username w-100"
                  />
                  {resetPwdFormErrors.enteredCaptcha && (
                    <div className="error-message text-start text-danger align-items-left fs-error">
                      {resetPwdFormErrors.enteredCaptcha}
                    </div>
                  )}
                </div>
              </div>
              <div className="captcha-display">
                <CaptchaImage captcha={captcha} />
              </div>

              <div className="text-center pt-1 mt-4 pb-1">
                <Button
                  label={"SUBMIT"}
                  onClick={handleOnSubmit}
                  className="mb-4 w-100 next-button"
                  style={{
                    backgroundColor: "#002133",
                  }}
                  loading={isSubmitting}
                />
              </div>
            </div>
            {/* Mobile View End */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetNewPassword;
